(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-arp-rakhi-root]';
  var INTRO_CLASSES = ['arp-intro-idle', 'arp-intro-tied', 'arp-intro-revealing', 'arp-intro-revealed'];
  var initializedRoots = new WeakSet();

  function initRakhiExperience(root) {
    if (!root || initializedRoots.has(root)) return;
    initializedRoots.add(root);
    root.dataset.arpInitialized = 'true';
    root.dataset.arpScriptVersion = '19';
    root.classList.add('arp-note-motion-ready');

    var intro = root.querySelector('[data-arp-intro]');
    var statusText = root.querySelector('[data-arp-status]');
    var tieTimer = null;
    var revealTimer = null;

    var modal = root.querySelector('[data-arp-modal]');
    var noteStep = root.querySelector('[data-arp-note-step]');
    var modalImage = root.querySelector('[data-arp-modal-image]');
    var modalTitle = root.querySelector('[data-arp-modal-product-title]');
    var modalScent = root.querySelector('[data-arp-modal-scent]');
    var modalPrice = root.querySelector('[data-arp-modal-price]');
    var modalComparePrice = root.querySelector('[data-arp-modal-compare-price]');
    var modalDiscount = root.querySelector('[data-arp-modal-discount]');
    var noteIntro = root.querySelector('[data-arp-note-intro]');
    var noteBody = root.querySelector('[data-arp-note-body]');
    var noteSignoff = root.querySelector('[data-arp-note-signoff]');
    var noteRecipient = root.querySelector('[data-arp-note-recipient]');
    var lineup = root.querySelector('[data-arp-lineup]');
    var lineupLabel = root.querySelector('[data-arp-lineup-label]');
    var lineupTitle = root.querySelector('[data-arp-lineup-title]');
    var lineupCopy = root.querySelector('[data-arp-lineup-copy]');
    var addGiftButton = root.querySelector('[data-arp-add-gift]');
    var addError = root.querySelector('[data-arp-add-error]');
    var toast = root.querySelector('[data-arp-toast]');
    var noteReveal = root.querySelector('[data-arp-note-reveal]');
    var noteRevealObserver = null;
    var noteRevealArmed = false;
    var noteRevealTimer = null;
    var activeForm = null;
    var activePrice = '';
    var selectedAudience = '';
    var chosenRecipient = '';
    var chosenNote = '';
    var lastTrigger = null;
    var productRequestCache = new Map();

    function clearTimers() {
      if (tieTimer) window.clearTimeout(tieTimer);
      if (revealTimer) window.clearTimeout(revealTimer);
      tieTimer = null;
      revealTimer = null;
    }

    function playNoteReveal() {
      if (!noteReveal || noteReveal.dataset.arpNotePlayed === 'true') return;
      noteReveal.dataset.arpNotePlayed = 'true';
      noteReveal.classList.remove('is-note-revealed');
      void noteReveal.offsetWidth;
      noteReveal.classList.add('is-note-revealing');
      noteRevealTimer = window.setTimeout(function () {
        noteReveal.classList.remove('is-note-revealing');
        noteReveal.classList.add('is-note-revealed');
      }, 3900);
    }

    function armNoteReveal() {
      if (!noteReveal || noteRevealArmed) return;
      noteRevealArmed = true;

      window.setTimeout(function () {
        if (!('IntersectionObserver' in window)) {
          playNoteReveal();
          return;
        }

        noteRevealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.3) return;
            playNoteReveal();
            if (noteRevealObserver) noteRevealObserver.disconnect();
          });
        }, { threshold: [0.3, 0.55] });

        noteRevealObserver.observe(noteReveal);
      }, 180);
    }

    function setPhase(phase, restartAnimation) {
      INTRO_CLASSES.forEach(function (className) {
        root.classList.remove(className);
      });
      if (restartAnimation) void root.offsetWidth;
      root.classList.add('arp-intro-' + phase);

      if (intro) intro.setAttribute('aria-hidden', phase === 'revealed' ? 'true' : 'false');
      if (statusText) statusText.textContent = phase === 'idle' ? 'A little ritual begins…' : 'Rakhi tied with love';

      if (phase === 'revealed') {
        document.body.classList.remove('arp-rakhi-intro-locked');
        armNoteReveal();
      }
    }

    function scheduleTiedState() {
      tieTimer = window.setTimeout(function () {
        setPhase('tied');
      }, 3350);
    }

    function replayRitual() {
      clearTimers();
      document.body.classList.add('arp-rakhi-intro-locked');
      setPhase('idle', true);
      window.scrollTo({ top: 0, behavior: 'auto' });
      window.requestAnimationFrame(function () {
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
      window.setTimeout(function () {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 80);
      scheduleTiedState();
    }

    function revealExperience() {
      if (root.classList.contains('arp-intro-revealing') || root.classList.contains('arp-intro-revealed')) return;
      clearTimers();
      setPhase('revealing');
      if (navigator.vibrate) navigator.vibrate(14);
      revealTimer = window.setTimeout(function () {
        setPhase('revealed');
      }, 1650);
    }

    function skipExperience() {
      clearTimers();
      setPhase('revealed');
    }

    function productImageUrl(source, width) {
      var rawUrl = source && typeof source === 'object' ? (source.src || source.url) : source;
      if (!rawUrl) return '';

      try {
        var parsedUrl = new URL(rawUrl, window.location.origin);
        parsedUrl.searchParams.set('width', String(width));
        return parsedUrl.toString();
      } catch (error) {
        return rawUrl;
      }
    }

    function formatProductMoney(value) {
      var cents = Number(value || 0);
      var currency = root.dataset.currencyCode || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      var fractionDigits = cents % 100 === 0 ? 0 : 2;

      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits
        }).format(cents / 100);
      } catch (error) {
        return '₹' + (cents / 100).toFixed(fractionDigits);
      }
    }

    function getProductJson(handle) {
      if (productRequestCache.has(handle)) return productRequestCache.get(handle);

      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var request = window.fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      });

      productRequestCache.set(handle, request);
      return request;
    }

    function hydrateProductCard(card) {
      if (!card) return Promise.resolve();
      if (card._arpHydrationPromise) return card._arpHydrationPromise;

      var handle = card.dataset.arpProductHandle || '';
      var image = card.querySelector('.arp-product-media img');
      var price = card.querySelector('[data-arp-card-price]');
      var comparePrice = card.querySelector('[data-arp-card-compare-price]');
      var discount = card.querySelector('[data-arp-card-discount]');
      var button = card.querySelector('[data-arp-personalise]');
      var buttonText = button ? button.querySelector('span') : null;
      var variantInput = card.querySelector('[data-arp-variant-id]');

      card._arpHydrationPromise = getProductJson(handle).then(function (product) {
        var variants = Array.isArray(product.variants) ? product.variants : [];
        var variant = variants.find(function (item) { return item.available; }) || variants[0];
        if (!variant) throw new Error('Product has no variant');

        var rawImage = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
        var image480 = productImageUrl(rawImage, 480);
        var image720 = productImageUrl(rawImage, 720);
        var image900 = productImageUrl(rawImage, 900);
        var currentPrice = Number(variant.price || 0);
        var currentComparePrice = Number(variant.compare_at_price || 0);
        var hasDiscount = currentComparePrice > currentPrice;
        var discountPercent = hasDiscount ? Math.round(((currentComparePrice - currentPrice) * 100) / currentComparePrice) : 0;
        var currentPriceLabel = formatProductMoney(currentPrice);
        var currentComparePriceLabel = hasDiscount ? formatProductMoney(currentComparePrice) : '';

        if (image && image900) {
          image.src = image900;
          image.srcset = image480 + ' 480w, ' + image720 + ' 720w, ' + image900 + ' 900w';
        }
        if (price) price.textContent = currentPriceLabel;
        if (comparePrice) {
          comparePrice.textContent = hasDiscount ? 'MRP ' + currentComparePriceLabel : '';
          comparePrice.hidden = !hasDiscount;
        }
        if (discount) {
          discount.textContent = hasDiscount ? 'Save ' + discountPercent + '%' : '';
          discount.hidden = !hasDiscount;
        }
        if (variantInput) variantInput.value = String(variant.id || '');

        if (button) {
          button.dataset.price = currentPriceLabel;
          button.dataset.comparePrice = currentComparePriceLabel;
          button.dataset.discountLabel = hasDiscount ? 'Save ' + discountPercent + '%' : '';
          button.dataset.image = image720;
          button.disabled = !variant.available;
          button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        }
        if (buttonText) buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';

        card.classList.remove('is-product-loading', 'is-product-error');
        card.classList.add('is-product-ready');
        card.setAttribute('aria-busy', 'false');
      }).catch(function () {
        if (price) price.textContent = 'Unavailable';
        if (buttonText) buttonText.textContent = 'Unavailable';
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        }
        card.classList.remove('is-product-loading');
        card.classList.add('is-product-error');
        card.setAttribute('aria-busy', 'false');
      });

      return card._arpHydrationPromise;
    }

    function hydrateAllProducts() {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-arp-product-handle]'));
      var nextCardIndex = 0;
      var workerCount = Math.min(6, cards.length);

      function hydrateNext() {
        if (nextCardIndex >= cards.length) return Promise.resolve();
        var card = cards[nextCardIndex];
        nextCardIndex += 1;
        return hydrateProductCard(card).then(hydrateNext);
      }

      var workers = [];
      for (var workerIndex = 0; workerIndex < workerCount; workerIndex += 1) workers.push(hydrateNext());
      return Promise.all(workers);
    }

    document.body.classList.add('arp-rakhi-intro-locked');
    setPhase('idle', true);
    scheduleTiedState();

    function applyAudience(button) {
      selectedAudience = button.dataset.arpAudience || '';
      if (!selectedAudience) return;

      root.querySelectorAll('[data-arp-audience]').forEach(function (audienceButton) {
        var isActive = audienceButton === button;
        audienceButton.classList.toggle('is-active', isActive);
        audienceButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      root.querySelectorAll('[data-arp-person]').forEach(function (card) {
        var person = card.dataset.arpPerson || '';
        var shouldShow = person === selectedAudience || person === 'Both';
        var audienceOrder = selectedAudience === 'Bhai' ? card.dataset.arpOrderBhai : card.dataset.arpOrderBehen;
        card.style.order = audienceOrder || '99';
        card.classList.toggle('is-filtered-out', !shouldShow);
      });

      if (lineupLabel) lineupLabel.textContent = selectedAudience === 'Bhai' ? 'Curated for your bhai' : 'Curated for your behen';
      if (lineupTitle) lineupTitle.textContent = selectedAudience === 'Bhai' ? 'Gifts for his world.' : 'Gifts for her space.';
      if (lineupCopy) lineupCopy.textContent = selectedAudience === 'Bhai'
        ? 'Car favourites, bold reeds and darker candle notes—picked for him.'
        : 'Warm candles, graceful reeds and beautiful diffusers—picked for her.';

      if (lineup) {
        lineup.hidden = false;
        lineup.classList.remove('is-lineup-ready');
        void lineup.offsetWidth;
        lineup.classList.add('is-lineup-ready');

        window.setTimeout(function () {
          var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var scrollOffset = window.innerWidth <= 800 ? 82 : 112;
          var lineupTop = window.pageYOffset + lineup.getBoundingClientRect().top - scrollOffset;
          window.scrollTo({
            top: Math.max(0, lineupTop),
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
          });
        }, 120);
      }
    }

    function resetRecipientFlow() {
      chosenRecipient = '';
      chosenNote = '';
      if (noteStep) noteStep.hidden = false;
      if (addError) {
        addError.hidden = true;
        addError.textContent = '';
      }
      if (addGiftButton) {
        addGiftButton.disabled = false;
        addGiftButton.removeAttribute('aria-busy');
        addGiftButton.textContent = 'Add gift to bag' + (activePrice ? ' · ' + activePrice : '');
      }
    }

    function openGiftFlow(trigger) {
      var formId = trigger.dataset.formId;
      activeForm = formId ? document.getElementById(formId) : null;
      if (!activeForm || !modal) return;

      lastTrigger = trigger;
      activePrice = trigger.dataset.price || '';
      if (modalImage) {
        modalImage.src = trigger.dataset.image || '';
        modalImage.alt = trigger.dataset.title || 'Selected Aromahpure gift';
      }
      if (modalTitle) modalTitle.textContent = trigger.dataset.title || '';
      if (modalScent) modalScent.textContent = trigger.dataset.scent || '';
      if (modalPrice) modalPrice.textContent = activePrice;
      if (modalComparePrice) {
        var comparePrice = trigger.dataset.comparePrice || '';
        modalComparePrice.textContent = comparePrice ? 'MRP ' + comparePrice : '';
        modalComparePrice.hidden = !comparePrice;
      }
      if (modalDiscount) {
        var discountLabel = trigger.dataset.discountLabel || '';
        modalDiscount.textContent = discountLabel;
        modalDiscount.hidden = !discountLabel;
      }

      resetRecipientFlow();
      var audienceButton = root.querySelector('[data-arp-audience="' + selectedAudience + '"]');
      if (!audienceButton) return;
      selectRecipient(audienceButton);
      modal.hidden = false;
      document.body.classList.add('arp-rakhi-modal-open');
      window.requestAnimationFrame(function () {
        var copyButton = modal.querySelector('[data-arp-copy-code]');
        if (copyButton) copyButton.focus();
      });
    }

    function closeGiftFlow() {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('arp-rakhi-modal-open');
      activeForm = null;
      activePrice = '';
      resetRecipientFlow();
      if (lastTrigger) lastTrigger.focus();
    }

    function selectRecipient(button) {
      chosenRecipient = button.dataset.arpAudience || '';
      chosenNote = button.dataset.noteBody || '';
      var noteLabel = button.dataset.noteLabel || chosenRecipient;
      var signoff = button.dataset.noteSignoff || '';

      if (noteIntro) noteIntro.textContent = 'Beautifully printed and tucked inside the order for ' + noteLabel.toLowerCase() + '.';
      if (noteBody) noteBody.textContent = chosenNote;
      if (noteSignoff) noteSignoff.textContent = signoff;
      if (noteRecipient) noteRecipient.textContent = chosenRecipient === 'Bhai' ? 'For your bhai · packed with joy' : 'For your behen · packed with joy';
      if (noteStep) noteStep.hidden = false;
      if (addGiftButton) {
        addGiftButton.textContent = 'Add gift to bag' + (activePrice ? ' · ' + activePrice : '');
      }
    }

    function copyShagunCode(button) {
      var code = button.dataset.code || 'SHAGUN101';

      function markCopied() {
        button.classList.add('is-copied');
        button.textContent = 'Copied ✓';
        window.setTimeout(function () {
          button.classList.remove('is-copied');
          button.textContent = 'Copy code';
        }, 1800);
      }

      function fallbackCopy() {
        var helper = document.createElement('textarea');
        helper.value = code;
        helper.setAttribute('readonly', 'readonly');
        helper.style.position = 'fixed';
        helper.style.opacity = '0';
        document.body.appendChild(helper);
        helper.select();
        document.execCommand('copy');
        helper.remove();
        markCopied();
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(fallbackCopy);
        return;
      }

      fallbackCopy();
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      window.setTimeout(function () {
        toast.hidden = true;
      }, 2600);
    }

    function findVisibleCartButton() {
      var candidates = document.querySelectorAll(
        'button[aria-label="Cart"], button[aria-label*="cart" i], [data-testid="header-cart-button"], a[href$="/cart"]'
      );
      for (var i = 0; i < candidates.length; i += 1) {
        var element = candidates[i];
        if (root.contains(element)) continue;
        var rect = element.getBoundingClientRect();
        var style = window.getComputedStyle(element);
        if (rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden') return element;
      }
      return null;
    }

    async function addGiftToCart() {
      if (!activeForm || !chosenRecipient || !chosenNote || !addGiftButton) return;

      var recipientInput = activeForm.querySelector('[data-arp-property-recipient]');
      var noteInput = activeForm.querySelector('[data-arp-property-note]');
      var cardToPack = chosenRecipient === 'Bhai' ? 'Bhai Card' : 'Behen Card';
      if (recipientInput) recipientInput.value = cardToPack;
      if (noteInput) noteInput.value = chosenNote;

      addGiftButton.disabled = true;
      addGiftButton.setAttribute('aria-busy', 'true');
      addGiftButton.textContent = 'Adding your gift…';
      if (addError) {
        addError.hidden = true;
        addError.textContent = '';
      }

      try {
        var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        var response = await window.fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(activeForm)
        });

        if (!response.ok) {
          var errorPayload = await response.json().catch(function () { return {}; });
          throw new Error(errorPayload.description || errorPayload.message || 'This gift could not be added right now.');
        }

        var addedItem = await response.json();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'arp-rakhi', item: addedItem, cardToPack: cardToPack } }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'arp-rakhi', item: addedItem, cardToPack: cardToPack } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'arp-rakhi', item: addedItem, cardToPack: cardToPack } }));

        modal.hidden = true;
        document.body.classList.remove('arp-rakhi-modal-open');
        showToast(cardToPack + ' selected — opening your bag…');

        window.setTimeout(function () {
          var cartButton = findVisibleCartButton();
          if (cartButton) cartButton.click();
        }, 220);

        activeForm = null;
        activePrice = '';
        chosenRecipient = '';
        chosenNote = '';
      } catch (error) {
        if (addError) {
          addError.textContent = error && error.message ? error.message : 'This gift could not be added right now. Please try again.';
          addError.hidden = false;
        }
      } finally {
        addGiftButton.disabled = false;
        addGiftButton.removeAttribute('aria-busy');
        if (!modal.hidden) addGiftButton.textContent = 'Add gift to bag' + (activePrice ? ' · ' + activePrice : '');
      }
    }

    function eventControl(event, selector) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (var i = 0; i < path.length; i += 1) {
        var node = path[i];
        if (node && node.nodeType === 1 && node.matches && node.matches(selector)) return node;
      }
      var target = event.target;
      return target && target.nodeType === 1 && target.closest ? target.closest(selector) : null;
    }

    function handleCampaignClick(event) {
      var campaignRoot = eventControl(event, ROOT_SELECTOR);
      if (campaignRoot !== root) return;

      var control = eventControl(event, '[data-arp-enter]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        revealExperience();
        return;
      }

      control = eventControl(event, '[data-arp-skip]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        skipExperience();
        return;
      }

      control = eventControl(event, '[data-arp-replay]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        replayRitual();
        return;
      }

      control = eventControl(event, '[data-arp-audience]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyAudience(control);
        return;
      }

      control = eventControl(event, '[data-arp-personalise]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGiftFlow(control);
        return;
      }

      control = eventControl(event, '[data-arp-copy-code]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        copyShagunCode(control);
        return;
      }

      control = eventControl(event, '[data-arp-modal-close]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeGiftFlow();
        return;
      }

      control = eventControl(event, '[data-arp-add-gift]');
      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addGiftToCart();
        return;
      }

      if (event.target === modal) closeGiftFlow();
    }

    window.addEventListener('click', handleCampaignClick, true);

    var boundControls = new WeakSet();
    var controlSelector = [
      '[data-arp-enter]',
      '[data-arp-skip]',
      '[data-arp-replay]',
      '[data-arp-audience]',
      '[data-arp-personalise]',
      '[data-arp-copy-code]',
      '[data-arp-modal-close]',
      '[data-arp-add-gift]'
    ].join(',');

    function bindCampaignControls() {
      root.querySelectorAll(controlSelector).forEach(function (control) {
        if (boundControls.has(control)) return;
        boundControls.add(control);
        control.addEventListener('click', handleCampaignClick, true);
      });
    }

    bindCampaignControls();
    window.setTimeout(bindCampaignControls, 250);
    window.setTimeout(bindCampaignControls, 1200);

    if ('MutationObserver' in window) {
      var controlsObserver = new MutationObserver(bindCampaignControls);
      controlsObserver.observe(root, { childList: true, subtree: true });
    }

    hydrateAllProducts();

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeGiftFlow();
    });

  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRakhiExperience);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
